import { memo } from "react";
import { TableEntity } from "src/components-mui/base/table-scrollable/components/entity/table-entity";
import { ITraderAvatarProps, ITraderAvatarUser, TraderAvatar } from "src/components-mui/common/trader-avatar/trader-avatar";
import { useGetUserName } from "src/hooks/use-get-user-name";
import { useLinkBuilder } from "src/hooks/use-link-builder";

interface ITableTraderEntityProps {
    wikifolioShortDescription: string;
    wikifolioSymbol: string;
    trader: ITraderAvatarUser;
    openLinksInNewTab?: boolean;
    avatarLoading?: NonNullable<ITraderAvatarProps["loading"]>;
}

export const TableTraderEntity = memo(
    ({ wikifolioShortDescription, wikifolioSymbol, trader, openLinksInNewTab = false, avatarLoading }: ITableTraderEntityProps) => {
        const { buildWikifolioLink, buildTraderProfileLink } = useLinkBuilder();
        const getUserName = useGetUserName();
        const traderProfileLink = buildTraderProfileLink(trader.nickName);

        return (
            <TableEntity
                title={wikifolioShortDescription}
                titleUrl={buildWikifolioLink(wikifolioSymbol)}
                name={getUserName(trader)}
                nameUrl={traderProfileLink}
                openLinksInNewTab={openLinksInNewTab}
                AvatarComponent={
                    <TraderAvatar
                        size="sm"
                        trader={trader}
                        href={traderProfileLink}
                        loading={avatarLoading}
                        {...(openLinksInNewTab ? { target: "_blank" } : {})}
                    />
                }
            />
        );
    }
);

TableTraderEntity.displayName = "TableTraderEntity";
